/* eslint-disable no-invalid-this */
/* eslint-disable max-statements */
/* eslint-disable max-params */
/* eslint-disable max-len */

import accountsService from './accounts.service';
import ApiService from './ApiService';
import intervenerService from './interveners.service';
import operationsService from './operations.service';
import issuesService from './issues.service';

/**
 * @override
 */
class DocumentsService extends ApiService {

    /**
     * Obtenemos un documento
     * @param {*} type Tipo de documento: Account/Intervener....
     * @param {*} uuid Identificador del padre al que pertenece el documento
     * @param {*} uuidDocument Identificador del documento
     * @return {Object} Response data
     */
    get(type, uuid, uuidDocument) {
        const entity = type.toUpperCase();
        const returnDefault =  true;
        const serviceType = {
            'ACCOUNT': accountsService.getDocument,
            'ISSUES': issuesService.getDocument,
            'INTERVENER': intervenerService.getDocument,
            'INTERVENERS': intervenerService.getDocument,
            'OPERATION': operationsService.getDocument
        };
        return serviceType[entity](uuid, uuidDocument) || returnDefault;
    }

    /**
     * Subimos un documento
     * @param {Object} payload Info del upload
     * @return {Object} Response data
     */
    upload(payload) {
        const entity = payload.section.toUpperCase();
        const returnDefault =  true;
        const serviceType = {
            'ACCOUNT': accountsService.upload,
            'INTERVENER': intervenerService.upload,
            'INTERVENERS': intervenerService.upload,
            'OPERATION': operationsService.upload
        };
        return serviceType[entity](payload) || returnDefault;
    }

    /**
     * Actualizamos un documento
     * @param {*} type Tipo de documento: Account/Intervener....
     * @param {*} payload Información para actualizar
     * @return {Object} Response data
     */
    update(type, payload) {
        const entity = type.toUpperCase();
        const { uuid, uuidDocument, data } = payload;
        const returnDefault =  true;
        const serviceType = {
            'ACCOUNT': accountsService.updateDocument,
            'INTERVENER': intervenerService.updateDocument,
            'INTERVENERS': intervenerService.updateDocument,
            'OPERATION': operationsService.updateDocument
        };

        return serviceType[entity](uuid, uuidDocument, data) || returnDefault;
    }

    /**
     * Remove document
     * @param {String} uuid_entity UUID intervener, account, operation...
     * @param {String} uuid_document Document UUID
     * @return {Object} Response data
     */

    removeDocument(type, uuid_entity, uuid_document) {
        const entity = type.toUpperCase();
        const returnDefault =  true;
        const serviceType = {
            'ACCOUNT': accountsService.removeDocument,
            'INTERVENER': intervenerService.removeDocument,
            'INTERVENERS': intervenerService.removeDocument,
            'OPERATION': operationsService.removeDocument
        };

        return serviceType[entity](uuid_entity, uuid_document) || returnDefault;
    }
}

const documentsService = new DocumentsService();

export default documentsService;
